import { MessageComponent } from './../../setting/message/message.component';
import { EditStatusComponent } from './../../blog/edit-status/edit-status.component';
import { EditBioComponent } from './../../blog/edit-bio/edit-bio.component';
import { BlogUserModel } from './../../../core/model/object/blog-user-model';
import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { BottomsheetShared } from '../shared/bottomsheet-shared';
import { EditNameComponent } from '../../setting/edit-name/edit-name.component';
import { User } from 'src/app/core/model/user-model';
import { EditGenderComponent } from '../../setting/edit-gender/edit-gender.component';
import { EditBirthdateComponent } from '../../setting/edit-birthdate/edit-birthdate.component';
import { EditHeightComponent } from '../../setting/edit-height/edit-height.component';
import { EditWeightComponent } from '../../setting/edit-weight/edit-weight.component';
import { SnackBarService } from 'src/app/data/repository/utils-repository/snack-bar.service';

@Component({
  selector: 'app-edit-bottomsheet',
  templateUrl: './edit-bottomsheet.component.html',
  styleUrls: ['./edit-bottomsheet.component.scss'],
})
export class EditBottomsheetComponent implements OnInit {
  @Input() type: string;
  @Input() user: User;
  @Input() blogUser: BlogUserModel;
  @Input() faqId: string | null;
  @ViewChild(EditNameComponent) child0: EditNameComponent;
  @ViewChild(EditGenderComponent) child1: EditGenderComponent;
  @ViewChild(EditBirthdateComponent) child2: EditBirthdateComponent;
  @ViewChild(EditWeightComponent) child3: EditWeightComponent;
  @ViewChild(EditHeightComponent) child4: EditHeightComponent;
  @ViewChild(EditBioComponent) child5: EditBioComponent;
  @ViewChild(EditStatusComponent) child6: EditStatusComponent;
  @ViewChild(MessageComponent) child7: MessageComponent;

  submit: boolean = true;
  title: string;
  selectedInput: string;
  edditing: boolean = true;
  showLoading = false;

  constructor(
    private bottomsheetShared: BottomsheetShared,
    private snackBarService: SnackBarService
  ) {}

  ngOnInit() {
    this.prepare();
    document
      .getElementById('bottomsheet')
      .addEventListener('click', (e) => e.stopPropagation());
    setTimeout(() => {
      document.getElementById('bottomsheet').style.transform =
        'translate(0, 0)';
    }, 10);
  }

  closeBottomsheet() {
    document.getElementById('bottomsheet').style.transform =
      'translate(0, 100%)';
    setTimeout(() => {
      this.bottomsheetShared.closeBottomsheet();
    }, 300);
  }

  closeAndUpdateBottomsheet() {
    document.getElementById('bottomsheet').style.transform =
      'translate(0, 100%)';
    setTimeout(() => {
      this.bottomsheetShared.closeAndUpdateBottomsheet();
    }, 300);
  }

  save() {
    this.showLoading = true;
    switch (this.type) {
      case 'name': {
        this.child0.save().then((res) => {
          if (res.isSuccess()) {
            this.closeAndUpdateBottomsheet();
          } else {
            this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
          }
          this.showLoading = false;
        });
        break;
      }
      case 'gender': {
        this.child1.save().then((res) => {
          if (res.isSuccess()) {
            this.closeAndUpdateBottomsheet();
          } else {
            this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
          }
          this.showLoading = false;
        });
        break;
      }
      case 'birthdate': {
        this.child2.save().then((res) => {
          if (res.isSuccess()) {
            this.closeAndUpdateBottomsheet();
          } else {
            this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
          }
          this.showLoading = false;
        });
        break;
      }
      case 'height': {
        this.child4.save().then((res) => {
          if (res.isSuccess()) {
            this.closeAndUpdateBottomsheet();
          } else {
            this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
          }
          this.showLoading = false;
        });
        break;
      }
      case 'bio': {
        this.child5.save().then((res) => {
          if (res.isSuccess()) {
            this.closeAndUpdateBottomsheet();
          } else {
            this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
          }
          this.showLoading = false;
        });
        break;
      }
      case 'isPublic': {
        this.child6.save().then((res) => {
          if (res.isSuccess()) {
            this.closeAndUpdateBottomsheet();
          } else {
            this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
          }
          this.showLoading = false;
        });
        break;
      }
      case 'username': {
        this.child0.save().then((res) => {
          if (res.isSuccess()) {
            this.closeAndUpdateBottomsheet();
          } else {
            // this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
          }
          this.showLoading = false;
        });
        break;
      }
      case 'message': {
        this.child7.save(this.faqId).then((res) => {
          if (res.isSuccess()) {
            this.closeBottomsheet();
            this.snackBarService.showSnackBar('پیام شما با موفقیت ارسال شد ');
          } else {
            this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
          }
          this.showLoading = false;
        });
        break;
      }
      default: {
        this.child0.save().then((res) => {
          if (res.isSuccess()) {
            this.closeAndUpdateBottomsheet();
          } else {
            this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
          }
          this.showLoading = false;
        });
      }
    }
  }

  prepare() {
    this.submit = true;

    switch (this.type) {
      case 'name': {
        this.title = 'نام';
        this.selectedInput = this.blogUser.name;
        break;
      }
      case 'gender': {
        this.title = 'جنسیت';
        this.selectedInput = this.user.sex;
        break;
      }
      case 'birthdate': {
        this.title = 'تاریخ تولد';
        this.selectedInput = this.user.birthDate.toString();
        break;
      }
      case 'height': {
        this.title = 'قد';
        this.selectedInput = this.user.height.toString();
        break;
      }
      case 'username': {
        this.title = 'نام کاربری';
        this.selectedInput = this.blogUser.userName;
        break;
      }
      case 'bio': {
        this.title = 'درباره من';
        this.selectedInput = this.blogUser.bio;
        break;
      }
      case 'isPublic': {
        this.title = 'وضعیت صفحه';
        this.selectedInput = this.blogUser.status;
        break;
      }
      case 'blocks': {
        this.title = 'حساب های کاربری مسدود شده';
        // this.selectedInput = this.user.height.toString();
        this.submit = false;
        break;
      }
      case 'message': {
        this.title = this.faqId === null ? 'ارسال پیام' : 'گزارش مشکل';
        this.edditing = false;
        this.submit = true;
        break;
      }
      case 'credentials': {
        if (this.user.email) {
          this.title = 'ایمیل';
          this.selectedInput = this.user.email;
          this.edditing = false;
          this.submit = false;
        } else {
          this.title = 'شماره تلفن';
          this.selectedInput = this.user.username;
          this.edditing = false;
          this.submit = false;
        }
        break;
      }
      case 'support': {
        this.title = 'تماس با پشتیبانی';
        this.submit = false;
        this.edditing = false;
        break;
      }
      default: {
        this.closeBottomsheet();
      }
    }
  }
}
